module.exports = __webpack_public_path__ + "static/media/MT.abc8de2b.wav";